import React, { useEffect, useState } from "react";
import { ShoppingCart, Star, ArrowRight } from "lucide-react";

const AMAZON_URL = "https://amzn.eu/d/0iLs59IO";

export default function StickyPurchaseBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show after the user scrolled past the hero (~700px) and is not in the very last sections
      const y = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight - 600;
      setVisible(y > 700 && y < max);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-purchase-bar"
      className={`fixed left-0 right-0 z-40 transition-all duration-500 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-6 pointer-events-none"
      }`}
      style={{ bottom: "1rem" }}
    >
      <div className="max-w-[1100px] mx-auto px-4">
        <div className="bg-[#0B192C] text-[#F9F8F6] border border-[#0B192C] shadow-[0_20px_50px_-15px_rgba(11,25,44,0.5)] grid grid-cols-[1fr_auto] sm:grid-cols-[auto_1fr_auto_auto] items-center gap-3 sm:gap-5 px-4 sm:px-6 py-3">
          {/* Mini cover */}
          <div className="hidden sm:block w-12 h-16 bg-[#1E3557] border border-[#F9F8F6]/10 flex-shrink-0 overflow-hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_mare-method-shop-1/artifacts/xu3iw6tw_Immagine%202026-06-01%20154539.png"
              alt="Metodo di Mare"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Title + rating */}
          <div className="min-w-0">
            <p className="font-serif-display text-base sm:text-lg leading-tight truncate">
              Metodo di Mare
            </p>
            <div className="flex items-center gap-2 mt-0.5">
              <div className="flex gap-0.5">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={10}
                    fill="#D4B895"
                    strokeWidth={0}
                    className="text-[#D4B895]"
                  />
                ))}
              </div>
              <span className="text-[10px] uppercase tracking-[0.18em] text-[#F9F8F6]/70">
                4,9 · 33 recensioni
              </span>
            </div>
          </div>

          {/* Price */}
          <div className="hidden sm:block text-right">
            <p className="font-serif-display text-2xl leading-none">€19,90</p>
            <p className="text-[10px] uppercase tracking-[0.18em] text-[#F9F8F6]/60 mt-1">
              Spedizione inclusa
            </p>
          </div>

          {/* CTA */}
          <a
            href={AMAZON_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-purchase-btn"
            className="group inline-flex items-center gap-2 px-4 sm:px-6 py-3 bg-[#E89B6C] text-[#0B192C] text-xs uppercase tracking-[0.18em] hover:bg-[#F9F8F6] transition-colors whitespace-nowrap"
          >
            <ShoppingCart size={14} />
            <span className="hidden sm:inline">Acquista</span>
            <span className="sm:hidden">€19,90</span>
            <ArrowRight
              size={12}
              className="transition-transform group-hover:translate-x-1"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
